import styled from "styled-components";

const VideoPlayerWrap = styled.div`
  position: relative;
  padding-top: 56.25%;
  &>div{
    position: absolute;
    width: 100%!important;
    height: 100%!important;
    top: 0;
    left: 0;
  }
`

export default VideoPlayerWrap